// Vite entrypoint. Defers all wiring to client/app.

import { boot } from './app/boot.js';

boot().catch((err) => {
  console.error('Tiermark boot failed:', err);
  const overlay = document.getElementById('boot-overlay');
  if (overlay) {
    overlay.textContent = `Boot failed: ${err instanceof Error ? err.message : String(err)}`;
    overlay.style.color = '#ff8080';
  }
});
